<template>
  <div id="headersFornedores">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="8"
        >
          <div
            id="btnExportExcel"
            class="d-flex justify-end align-center px-4"
          >
            <dashboard-excel-export
              :headers="headers"
              :table="dadosFiltro.length > 0 ? dadosFiltro : dadosFaturamento"
              :titulo-relatorio="tituloRelatorio"
              :enable-btn="enableBtn"
              :data-inicial="dataInicial"
              :data-final="dataFinal"
              :empresa-select="empresaSelect"
              :cidade-select="cidades"
              :vendedor-select="vendedores"
              :area-select="areas"
              :rede-select="redes"
              :segmento="segmento"
              :arquivo="arquivo"
            />
          </div>
          <br>
          <div
            id="idTable"
            style="overflow-x: auto; max-width: 100%;"
          >
            <table
              style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Codigo cliente
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Cliente
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Data última compra
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Valor última compra
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                  >
                    Dias sem compra
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in dadosFiltro.length > 0 ? dadosFiltro : dadosFaturamento"
                  :key="item.id"
                >
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                  >
                    {{ item.codCliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                  >
                    {{ item.data }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.valor }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.diasCompra }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <v-col
          v-if="dadosFaturamento.length > 0"
          cols="12"
          sm="12"
          md="12"
          lg="4"
        >
          <br><br>
          <h4 class="text-center">
            Dias sem compra
          </h4>
          <v-row>
            <v-col
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <div id="minimo">
                {{ minimoFiltro > 0 ? minimoFiltro : minimo }}
              </div>
            </v-col>
            <v-col
              id="rangerId"
              cols="12"
              sm="9"
              md="9"
              lg="9"
            >
              <v-range-slider
                v-model="values"
                :min="minimo"
                :max="maximo"
                color="#424242"
                track-color="grey"
                thumb-label
                class="slider"
                @input="getFiltro"
              />
            </v-col>
            <v-col
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <div id="maximo">
                {{ maximoFiltro > 0 ? maximoFiltro : maximo }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import BaseAtendimento from '../../../../services/baseatendimento'
  import eventEmit from '../core/EventoEmit'

  export default {
    name: 'ShowDadosComparativoFaturamento',
    emits: ['setDadosBaseAtendimento'],
    components: {
      DashboardExcelExport: () => import('../core/ExportExcel'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleSlider: {
        color: '#000000',
      },
      value: 0,
      values: [],
      loading: false,
      error: null,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresaSelect: [],
      cidades: [],
      redes: [],
      vendedores: [],
      areas: [],
      segmento: [],
      headers: [
        { text: 'Codigo cliente', value: 'codCliente', width: '80px', align: 'left', class: 'black--text title' },
        { text: 'Cliente', value: 'cliente', width: '250px', align: 'left', class: 'black--text title' },
        { text: 'Data última compra', value: 'data', width: '95px', align: 'right', class: 'black--text title' },
        { text: 'Valor última compra', value: 'valor', width: '100px', align: 'right', class: 'black--text title' },
        { text: 'Dias sem compra', value: 'diasCompra', width: '100px', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamento: [],
      dadosFiltro: [],
      minimo: 0,
      maximo: 0,
      minimoFiltro: 0,
      maximoFiltro: 0,
      enableBtn: true,
      imprimindo: false,
      corPrimaria: localStorage.corPrimaria,
      tituloRelatorio: 'Relatório Base Atendimento',
      arquivo: 'relatorio_base_atendimento.xlsx',
    }),

    created () {
      eventEmit.$on('update-form-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-form-mais-vida', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, vendedorSelect, redeSelect, produtoSelect, linhaSelect, clienteSelect, segmento) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.empresaSelect = empresaSelect
        this.cidades = cidadeSelect
        this.vendedores = vendedorSelect
        this.redes = redeSelect
        this.areas = areaSelect
        this.segmento = segmento

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true
        this.dadosFaturamento = []
        this.minimo = 0
        this.maximo = 0
        this.value = 0
        this.values = []
        this.enableBtn = true
        this.minimoFiltro = 0
        this.maximoFiltro = 0

        await BaseAtendimento.showBaseAtendimento(this.dataInicial, this.dataFinal, this.empresaSelect, this.cidades, this.vendedores, this.redes, localStorage.tokencontrato, this.areas, this.segmento).then(resposta => {
          if (resposta.data.status) {
            this.minimo = resposta.data.minino
            this.values.push(this.minimo)
            this.enableBtn = false

            this.maximo = resposta.data.maximo
            this.values.push(this.maximo)

            this.dadosFaturamento = resposta.data.dadosFaturamento.map((item) => {
              var listaDadosFaturamento = ({
                codCliente: item.codCliente,
                cliente: item.cliente,
                data: item.data,
                valor: item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                diasCompra: item.diasCompra,
              })

              return listaDadosFaturamento
            }).sort((d1, d2) => d2.diasCompra - d1.diasCompra)

            eventEmit.$emit('set-dados-base-atendimento', this.dadosFaturamento)
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.dadosFaturamento = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getFiltro () {
        const valorMinimo = this.values[0]
        const valorMaximo = this.values[1]

        this.minimoFiltro = this.values[0]
        this.maximoFiltro = this.values[1]

        if (valorMinimo === this.minimo && valorMaximo === this.maximo) {
          this.minimoFiltro = 0
          this.maximoFiltro = 0

          this.dadosFiltro = []
          eventEmit.$emit('set-dados-base-atendimento', this.dadosFaturamento)
        } else {
          this.dadosFiltro = this.dadosFaturamento
            .filter(item => item.diasCompra >= valorMinimo && item.diasCompra <= valorMaximo)
            .sort((d1, d2) => d2.diasCompra - d1.diasCompra)

          eventEmit.$emit('set-dados-base-atendimento', this.dadosFiltro)
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #minimo {
      margin: 1.4rem 0 0 0rem !important;
      font-size: 12px;
    }

    #maximo {
      margin: -5rem 0 0 23rem !important;
      font-size: 12px;
    }

    #rangerId {
      margin: -3.5rem 0 0 1rem !important;
      max-width: 80vw;
    }

    #idTable {
      max-height: 500px;
      max-width: 90vw !important;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  #btnExportExcel {
    margin: -0.6rem 0 0 13rem
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #minimo {
    margin: 0.4rem 0 0 0.5rem;
  }

  #maximo {
    margin: 0.4rem 0 0 -1.5rem;
  }

  #textTable {
    font-size: 0.75rem !important
  }

  .slider >>> .v-slider__thumb-label {
    background-color: rgba(40, 99, 175, 0.6) !important;
    color: white !important;
    font-weight: bold;
    border-radius: 4px;
    bottom: -65px !important;
    top: auto !important
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
